import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['alert', 'alert-' + _ctx.type]),
    role: "alert"
  }, [
    _createVNode(_component_font_awesome_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
  ], 2))
}